import { PUBLIC_SERVER_URL } from '$env/static/public'
import { writable } from 'svelte/store'

export const newVersionAvailable = writable(false)

// When updating the frontend, increment both front and back and update at the same time
export const FRONTEND_VERSION = 4

export const checkVersion = async () => {
  try {
    const response = await fetch(`${PUBLIC_SERVER_URL}/api/frontend-version`)
    if (!response.ok) return

    const data = await response.json()
    const serverVersion = data.version

    if (parseInt(serverVersion) > FRONTEND_VERSION) {
      newVersionAvailable.set(true)
    }
  } catch (error) {
    console.error('Error checking frontend version:', error)
  }
}
